var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "custom-callout",
          {
            staticClass: "mb-3 custom-callout",
            attrs: {
              "border-color": _vm.item.status.color,
              "has-toggle": Boolean(_vm.item.instrument.description),
              opened: _vm.item.opened
            },
            on: { "click:open": _vm.open },
            scopedSlots: _vm._u(
              [
                _vm.item.instrument.description
                  ? {
                      key: "edition",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "p-2 custom-callout-edition" },
                            [
                              _c(
                                "div",
                                { staticClass: "bg-white rounded p-3" },
                                [
                                  _c("div", { staticClass: "label mb-2" }, [
                                    _c("i", {
                                      staticClass: "fas fa-file text-orange"
                                    }),
                                    _vm._v(" Descripción ")
                                  ]),
                                  _c("span", { staticClass: "info" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.item.instrument.description
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            )
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-5" }, [
                _c("div", { staticClass: "color-secondary-6 font-14" }, [
                  _vm._v(" Instrumento: ")
                ]),
                _c(
                  "div",
                  { staticClass: "font-weight-normal color-black font-16" },
                  [_vm._v(" " + _vm._s(_vm.item.instrument.name) + " ")]
                )
              ]),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "color-secondary-6 font-14" }, [
                  _vm._v(" Estatus: ")
                ]),
                _c(
                  "div",
                  { staticClass: "font-weight-normal color-black font-16" },
                  [
                    _c("custom-balloon", {
                      attrs: {
                        "background-color": _vm.item.status.color,
                        dot: "",
                        text: _vm.item.status.name
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "color-secondary-6 font-14" }, [
                  _vm._v(" Fecha de Completado: ")
                ]),
                _c(
                  "div",
                  { staticClass: "font-weight-normal color-black font-16" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm._f("date")(_vm.item.completedDate)) + " "
                    )
                  ]
                )
              ]),
              _c(
                "div",
                { staticClass: "col-2" },
                [
                  _c("action-button", {
                    attrs: {
                      i: _vm.canComplete
                        ? "fas fa-check-circle"
                        : "fas fa-file-import",
                      text: _vm.canComplete ? "Completar" : "Ver Instrumento",
                      variant: "outline-success mr-3 px-3"
                    },
                    on: {
                      click: function($event) {
                        return _vm.complete()
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }